import img1 from "../images/menu/img1.jpg";
import img2 from "../images/menu/img2.jpg";
import img3 from "../images/menu/img3.jpg";
import img4 from "../images/menu/img4.jpg";
import img5 from "../images/menu/img5.jpg";
import img6 from "../images/menu/img6.jpg";

export const imgMenuDigital = [
  {
    id: 10101,
    image: img1
  },
  {
    id: 10102,
    image: img2
  },
  {
    id: 10103,
    image: img3
  },
  {
    id: 10104,
    image: img4
  },
  {
    id: 10105,
    image: img5
  },
  {
    id: 10106,
    image: img6
  }  
];